module.exports = __webpack_public_path__ + "static/media/thumb_leccor.f21ac453.jpg";